module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBig.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBig.png
// module id = 230
// module chunks = 0